import React from 'react';
import {_defineHelpUrlandToolTip} from '../../helpers/index.js'

const LogicBoolean = function () {
    const name = "logic_boolean";
    LogicBoolean.blockName = name;

   _defineHelpUrlandToolTip(name, Blockly.BASE_HELP_URL + "#logic", "True or false value");

    return (
        <block type={name}></block>
    );
};

export default LogicBoolean;
